import { render, staticRenderFns } from "./BusinessJoinRead.vue?vue&type=template&id=3a3a7abc&scoped=true&"
import script from "./BusinessJoinRead.vue?vue&type=script&lang=js&"
export * from "./BusinessJoinRead.vue?vue&type=script&lang=js&"
import style0 from "./BusinessJoinRead.vue?vue&type=style&index=0&id=3a3a7abc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a7abc",
  null
  
)

export default component.exports